export default __webpack_public_path__ + "static/media/salab.9cfd7802.jpg";